
import React from 'react';
import { t, validateNonEmpty } from '@superset-ui/core';
import {
    ControlPanelConfig,
    sections,
    sharedControls,
    ControlStateMapping,
    emitFilterControl,
} from '@superset-ui/chart-controls';
import { DEFAULT_FORM_DATA } from './types';
import { legendSection } from '../../../controls';
import { commonControlsConfig } from '../utils';

const { showLabels } = DEFAULT_FORM_DATA;

const chartLegendSection = [...legendSection];
chartLegendSection.splice(2, 1);
 
const config: ControlPanelConfig = {
   controlPanelSections: [
    {
      ...sections.legacyRegularTime,
      expanded: false
    },
     {
       label: t('Query'),
       expanded: true,
       controlSetRows: [
        [
          {
            name: 'groupby',
            config: {
              ...sharedControls.groupby,
              label: t('Series A'),
              description: t('Outer Category Column.'),
              validators: [validateNonEmpty],
              multi: false
            }
          }
        ],
        [
          {
            name: 'groupby_inner',
            config: {
              ...sharedControls.groupby,
              label: t('Series B'),
              description: t('Inner Category Column.'),
              validators: [validateNonEmpty],
              multi: false
            }
          }
        ],
        ['metric'],
        ['adhoc_filters'],
        emitFilterControl,
        [
          {
              name: 'row_limit',
              config: {
              ...sharedControls.row_limit,
              default: 10,
              },
          },
        ]
       ],
     },
     {
       label: t('Chart Options'),
       tabOverride: 'customize',
       expanded: false,
       controlSetRows: [
        //  ['color_scheme'],
         ...chartLegendSection,
         // eslint-disable-next-line react/jsx-key
         [<div className="section-header">{t('Labels')}</div>],
         [
           {
             name: 'show_labels',
             config: {
               type: 'CheckboxControl',
               label: t('Show Labels'),
               renderTrigger: true,
               default: showLabels,
               description: t('Whether to display the labels.'),
             },
           },
         ],
         [
          {
            name: 'tooltipFormat',
            config: {
              ...commonControlsConfig.tooltipFormat,
              default: DEFAULT_FORM_DATA.tooltipFormat,
            },
          },
        ],
        [
          {
            name: 'labelFormat',
            config: {
              ...commonControlsConfig.labelFormat,
              default: DEFAULT_FORM_DATA.labelFormat,
            },
          },
        ],
        [
          {
            name: 'labelBackgroundColor',
            config: {
              ...sharedControls.color_picker,
              label: t('Label Background Color'),
              default: DEFAULT_FORM_DATA.labelBackgroundColor,
              renderTrigger: true,
            },
          },
        ],
        [
          {
            name: 'labelBorderColor',
            config: {
              ...sharedControls.color_picker,
              label: t('Label Border Color'),
              default: DEFAULT_FORM_DATA.labelBorderColor,
              renderTrigger: true,
            },
          },
        ],
        [
          {
            name: 'labelRichStyle',
            config: {
              ...commonControlsConfig.richStyle,
              label: t('Label Rich Style Json'),
              default: DEFAULT_FORM_DATA.labelRichStyle,
            },
          },
        ],
       ],
     },
   ],
   onInit(state: ControlStateMapping) {
     return {
       ...state,
       row_limit: {
         ...state.row_limit,
         value: state.row_limit.default,
       },
     };
   },
   denormalizeFormData: formData => ({
    ...formData,
    metric: formData.standardizedFormData.standardizedState.metrics[0],
    groupby: formData.standardizedFormData.standardizedState.columns,
   }),
   updateStandardizedState: (prevState, currState) => ({
     ...currState,
     metrics: [currState.metrics[0], ...prevState.metrics.slice(1)],
   }),
};
 
export default config;
 